import { useMemo } from 'react';

import { ESubscriptionStatus, TSubscription } from '@mopla/data-models';
import { EMlpIconTypes, EMplVariantTypes } from '@mopla/ui';

import { TCTAConfig } from './types';

interface IUseDTicketCTAConfigParams {
	subscription: TSubscription;
	onRefresh: () => void;
	onEditPaymentMethod: () => void;
}

export const useDTicketCTAConfig = ({
	subscription,
	onRefresh,
	onEditPaymentMethod,
}: IUseDTicketCTAConfigParams): TCTAConfig => {
	const isPending = subscription?.status === ESubscriptionStatus.PENDING;
	const isInvalid = subscription?.status === ESubscriptionStatus.INVALID;

	// TODO: redesign-dticket - determine payment_failed vs blocked based on actual data
	// For now, we'll use a placeholder logic - this should be refined based on actual API response
	const isPaymentFailed = isInvalid; // Placeholder: will need actual logic
	const isBlocked = false; // Placeholder: will need actual logic

	const ctaConfig = useMemo((): TCTAConfig => {
		if (isPending) {
			return {
				type: 'pending',
				messageKey: 'cta.pending.message',
				buttonLabelKey: 'cta.pending.button',
				iconType: EMlpIconTypes.Info,
				variant: EMplVariantTypes.Info,
				onAction: onRefresh,
			};
		}

		if (isPaymentFailed) {
			return {
				type: 'payment_failed',
				messageKey: 'cta.payment_failed.message',
				buttonLabelKey: 'cta.payment_failed.button',
				iconType: EMlpIconTypes.Warning,
				variant: EMplVariantTypes.Error,
				onAction: onEditPaymentMethod,
			};
		}

		if (isBlocked) {
			// TODO: redesign-dticket - get distributor email from subscription data
			const distributorEmail = 'vertreiber@mail.com';
			return {
				type: 'blocked',
				messageKey: 'cta.blocked.message',
				messageValues: { email: distributorEmail },
				iconType: EMlpIconTypes.Warning,
				variant: EMplVariantTypes.Error,
			};
		}

		return null;
	}, [isPending, isPaymentFailed, isBlocked, onRefresh, onEditPaymentMethod]);

	return ctaConfig;
};
